import { create } from "zustand"

type SearchStore = {
  value: string
  open: boolean
  setOpen(data: boolean): void
  setValue(data: string): void
}

export const useSearch = create<SearchStore>((set, get) => ({
  value: "",
  open: false,
  setOpen: (data) => set({ open: data }),
  setValue: (data) => set({ value: data }),
}))
